import { render, staticRenderFns } from "./source.vue?vue&type=template&id=6c359c78&"
import script from "./source.vue?vue&type=script&lang=js&"
export * from "./source.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\JG\\jg\\IWMS5.0\\SRM\\GIT\\SRM.VUE\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6c359c78')) {
      api.createRecord('6c359c78', component.options)
    } else {
      api.reload('6c359c78', component.options)
    }
    module.hot.accept("./source.vue?vue&type=template&id=6c359c78&", function () {
      api.rerender('6c359c78', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/demo/components/markdown/source.vue"
export default component.exports